import { render, staticRenderFns } from "./webNav.vue?vue&type=template&id=2250f55c&scoped=true&"
import script from "./webNav.vue?vue&type=script&lang=js&"
export * from "./webNav.vue?vue&type=script&lang=js&"
import style0 from "./webNav.vue?vue&type=style&index=0&id=2250f55c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2250f55c",
  null
  
)

export default component.exports